import { useMemo } from 'react';

import { useSWRV1IntilaqChallenges } from '~/api/v1/challenges/intilaq/get';
import { useSWRV1IntilaqChallengePosts } from '~/api/v1/challenges/intilaq/posts/get';
import { useSWRV2IntilaqOrganizations } from '~/api/v2/organizations/intilaq/get';
import { useSWRV2IntilaqPresentations } from '~/api/v2/presentations/intilaq/get';
import Layout from '~/pages/_layout.page';

import { About } from './_components/about';
import { Description } from './_components/description';
import { Header } from './_components/header';
import { Orgs } from './_components/orgs';
// import { Partners } from './_components/partners';
import { Presentations } from './_components/presentations';
import { Projects } from './_components/projects';
import { Reports } from './_components/reports';
import { SocialIssues, categories } from './_components/socialIssues';

const BUDGETS = 926830000;

export default function Page() {
  const { challenges } = useSWRV1IntilaqChallenges();
  const { posts } = useSWRV1IntilaqChallengePosts();
  const { presentations } = useSWRV2IntilaqPresentations();
  const { organizations } = useSWRV2IntilaqOrganizations();

  const notes = useMemo(() => {
    if (!challenges) return [];

    return challenges.map((challenge) =>
      challenge.intilaq_note ? JSON.parse(challenge.intilaq_note) : {},
    );
  }, [challenges]);

  const description = useMemo(() => {
    if (!challenges || !notes) return [];

    const projectCount = challenges.length;
    const partnerCount = challenges.reduce(
      (acc, challenge) => {
        return (
          acc +
          challenge.organizations.length +
          challenge.corporates.length +
          challenge.partners.length
        );
      },
      organizations?.length || 0,
    );
    return [
      {
        label: 'プロジェクト数',
        value: projectCount,
      },
      {
        label: '連携団体数',
        value: partnerCount,
      },
      {
        label: '資金調達額 (千円)',
        value: BUDGETS / 1000,
      },
    ];
  }, [challenges, notes, organizations]);

  const socialIssues = useMemo(() => {
    if (!notes) return [];

    const data = {} as { [key: string]: number };
    notes.forEach((note) => {
      const { budgets, budget } = note;
      if (!budgets || !budget) return;
      budgets.forEach(({ category, percent }: { category: string; percent: string }) => {
        data[category] ||= 0;
        data[category] += (Number(budget) * Number(percent)) / 100;
      });
    });

    return categories.map((c) => ({
      category: c.title,
      value: data[c.title] || 0,
    }));
  }, [notes]);

  return (
    <Layout pageTitle={'INTILAQオンラインレポート'} pageDescription={'INTILAQオンラインレポート'}>
      <main className='w-full'>
        <Header />
        <Description values={description} />
        <SocialIssues data={socialIssues} />
        <Projects challenges={challenges?.slice(0, 3) || []} />
        <Reports posts={posts?.slice(0, 3) || []} />
        <About />
        {/* <Partners /> */}
        <Presentations presentations={presentations?.slice(0, 3) || []} />
        <Orgs organizations={organizations?.slice(0, 4) || []} />
      </main>
    </Layout>
  );
}
